<div (mouseenter)="openPicker()" (mouseleave)="closePicker()" class="c-datepicker">
	@if (icon) {
		<tvcore-icon class="c-datepicker__icon" [name]="icon"></tvcore-icon>
	}

	<tvcore-input (focusInput)="openPicker()" [label]="label" [name]="name" [showErrors]="showErrors">
		<ng-content></ng-content>
	</tvcore-input>

	<div [class.c-datepicker__overlay--show]="showPicker" class="c-datepicker__overlay">
		<div class="c-datepicker__header">
			<tvcore-icon (click)="prev()" name="chevron"></tvcore-icon>
			<span (click)="toggleView()">{{ title }}</span>
			<tvcore-icon (click)="next()" name="chevron"></tvcore-icon>
		</div>

		<ng-container *ngIf="view === 'day'">
			<div class="c-datepicker__days">
				<span>MA</span>
				<span>DI</span>
				<span>WO</span>
				<span>DO</span>
				<span>VR</span>
				<span>ZA</span>
				<span>ZO</span>
			</div>

			<ng-container *ngIf="days$ | async as days">
				<div *ngFor="let row of days" class="c-datepicker__row">
					<div
						(click)="select(day)"
						*ngFor="let day of row"
						[class.c-datepicker__day--invisible]="!day.visible"
						[class.c-datepicker__day--selected]="isSelected(day)"
						[class.c-datepicker__day--today]="day.isToday"
						class="c-datepicker__day"
					>
						{{ day.text }}
					</div>
				</div>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="view === 'month'">
			<div class="c-datepicker__months">
				<span (click)="setMonth(1)">Januari</span>
				<span (click)="setMonth(2)">Februari</span>
				<span (click)="setMonth(3)">Maart</span>
				<span (click)="setMonth(4)">April</span>
				<span (click)="setMonth(5)">Mei</span>
				<span (click)="setMonth(6)">Juni</span>
				<span (click)="setMonth(7)">Juli</span>
				<span (click)="setMonth(8)">Augustus</span>
				<span (click)="setMonth(9)">September</span>
				<span (click)="setMonth(10)">Oktober</span>
				<span (click)="setMonth(11)">November</span>
				<span (click)="setMonth(12)">December</span>
			</div>
		</ng-container>
	</div>
</div>
